export const navigationConstants = {
  BREADCRUMB_ADD_REQUEST: 'BREADCRUMB_ADD_REQUEST',
  BREADCRUMB_ADD: 'BREADCRUMB_ADD',
  TREE_REQUEST: 'TREE_REQUEST',
  TREE_ADD: 'TREE_ADD'
};
